export const SMAPLET_COMMENTS = ['none', 'maporium', 'disqus'] as const;

export type SmapletComments = (typeof SMAPLET_COMMENTS)[number];

export function isSmapletComments(value: unknown): value is SmapletComments {
  return typeof value === 'string' && (SMAPLET_COMMENTS as readonly string[]).includes(value);
}

/**
 * The comments a smaplet offers. `hasGuestComments` stays the switch for
 * Maporium comments, so a smap that only ever set it still reads right.
 */
export function smapletCommentsOf(
  map: {smapletComments?: string | null; hasGuestComments?: boolean | null} | null | undefined,
): SmapletComments {
  if (map?.smapletComments === 'disqus') return 'disqus';
  return map?.hasGuestComments ? 'maporium' : 'none';
}
